export default __webpack_public_path__ + "06937e9a69bb8074f87ba5e7d73661ad.twig";